import { BrandColours } from '@helpers/brand';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import HeadingSummaryBlock from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock';
import { BackgroundVariant } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import * as React from 'react';
import S from './InnerPageHero.styles';
const InnerPageHero = (props) => {
    const [animate, setAnimate] = React.useState(false);
    const srcs = props.image ? getSrcs(props.image, 3424, 375, 16, 695 / 376) : undefined;
    const sizes = props.variant === 'background-image'
        ? `${until(Device.TabletLarge)} 100vw, 60vw`
        : `${until(Device.TabletLarge)} 100vw, ${until(Device.DesktopLarge)} 40vw, 684px`;
    React.useEffect(() => {
        setAnimate(true);
    }, []);
    return (React.createElement(S.Container, { id: props.anchorId, flush: "top", "data-animate": animate, "data-layout": props.variant === 'centre-text' && props.image
            ? 'contained-image'
            : props.variant ?? 'contained-image', "data-primary": props.colours?.primary ?? BrandColours.PurpleLight, "data-secondary": props.colours?.secondary, "data-tertiary": props.colours?.tertiary, translations: props.translations },
        React.createElement(S.PrimaryBackground, null),
        React.createElement(S.SecondaryBackground, null),
        !props.image && React.createElement(S.TertiaryBackground, null),
        React.createElement(HeadingSummaryBlock, { ...props, summary: props.summary ? `<p>${props.summary}</p>` : undefined, layout: props.variant === 'centre-text' && !props.image ? 'central' : 'default', ctas: props.ctas?.map((cta) => ({
                ...cta,
                buttonType: cta.buttonType ? cta.buttonType : 'secondary',
            })), ctaWrapperVariant: props.colours?.primary !== BrandColours.White
                ? BackgroundVariant.Purple
                : BackgroundVariant.White, headingType: "h1" }),
        srcs && (React.createElement(S.ImageWrapper, null,
            React.createElement(S.Image, { src: srcs.src, srcSet: srcs.srcSet, alt: props.image?.altText, sizes: sizes, loading: "eager", decoding: "sync" // Ensure Safari loads the image correctly, and first
             })))));
};
export default InnerPageHero;
